import { useState, useEffect } from "react";

import Pic2 from  "../img/pic2.jpg"
import Pic3 from  "../img/pic3.jpg"
import Pic4 from  "../img/pic4.jpg"

function ImageSlider() {
  const images = [
  
    Pic2,
    Pic3,
    Pic4,
    
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000); // 2 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div>
      <img className="job-image" src={images[index]} alt="slider"  />
    </div>
  );
}

export default ImageSlider;